import { post } from '@core/api/baseApi';
import { ResultResponse } from '@core/types';
import { Patient } from '@core/types/Patient';

export type OverridePatientPayload = {
  // PatientID of the existing (target) patient.
  patientId: string;
  // Patient the current study belongs to; all of its studies move to the target.
  oldPatientKey: number;
  targetPatientKey: number;
  // ISO date (YYYY-MM-DD) or null.
  patientsBirthDate: string | null;
  patientsSex: string;
  patientsNameFamily: string;
  patientsNameGiven: string;
  patientsAge: string;
  patientsEmail: string;
  patientsPhoneNumber: string;
};

export type OverridePatientResult = Pick<
  Patient,
  | 'patientKey'
  | 'patientId'
  | 'patientsBirthDate'
  | 'patientsSex'
  | 'patientsNameFamily'
  | 'patientsNameGiven'
  | 'patientsAge'
  | 'patientsEmail'
  | 'patientsPhoneNumber'
> & {
  affectedStudyInstanceUids: string[];
};

const overridePatient = async (
  payload: OverridePatientPayload,
): Promise<ResultResponse<OverridePatientResult>> => await post(`/UserPatient/override`, payload);

export default overridePatient;
